import { render } from "./JadwalMapel.vue?vue&type=template&id=4f6f53d6"
import script from "./JadwalMapel.vue?vue&type=script&lang=js"
export * from "./JadwalMapel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__